import {
  Bell,
  Bluetooth,
  Compass,
  Monitor,
  PanelsTopLeft,
  Receipt,
  ShieldCheck,
  Truck,
  UserCog,
} from "@/components/icons";
import { ShopSettingsSection } from "@/modules/settings/presentation/ui/ShopSettingsSection";
import { ImportOrderSettingsSection } from "@/modules/settings/presentation/ui/ImportOrderSettingsSection";
import { CodRiskSettingsSection } from "@/modules/settings/presentation/ui/CodRiskSettingsSection";
import { LabelPrinterSettingsSection } from "@/modules/settings/presentation/ui/LabelPrinterSettingsSection";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/kit";
import { AccountSection } from "../ui/AccountSection";
import { AppearanceSection } from "../ui/AppearanceSection";
import { LayoutSection } from "../ui/LayoutSection";
import { NotificationsSection } from "../ui/NotificationsSection";
import { OnboardingSection } from "../ui/OnboardingSection";

const tabs = [
  { value: "shop", label: "\u0eae\u0ec9\u0eb2\u0e99 & \u0ec1\u0e8a\u0e94", icon: Receipt },
  { value: "label-printer", label: "\u0ec0\u0e84\u0eb7\u0ecd\u0ead\u0ead\u0e87\u0e9e\u0eb4\u0ea1\u0e9b\u0ec9\u0eb2\u0e8d", icon: Bluetooth },
  { value: "import", label: "\u0eaa\u0eb1\u0ec8\u0e87\u0e99\u0eb3\u0ec0\u0e82\u0ebb\u0ec9\u0eb2", icon: Truck },
  { value: "cod-risk", label: "COD / \u0e84\u0ea7\u0eb2\u0ea1\u0eaa\u0ec8\u0e8d\u0e87", icon: ShieldCheck },
  { value: "account", label: "\u0e9a\u0eb1\u0e99\u0e8a\u0eb5", icon: UserCog },
  { value: "appearance", label: "\u0eae\u0eb9\u0e9a\u0ea5\u0eb1\u0e81\u0eaa\u0eb0\u0e99\u0eb0", icon: Monitor },
  { value: "notifications", label: "\u0e81\u0eb2\u0e99\u0ec1\u0e88\u0ec9\u0e87\u0ec0\u0e95\u0eb7\u0ead\u0e99", icon: Bell },
  { value: "layout", label: "\u0ec2\u0e84\u0e87\u0eae\u0ec8\u0eb2\u0e87", icon: PanelsTopLeft },
  { value: "onboarding", label: "\u0e81\u0eb2\u0e99\u0ec1\u0e99\u0eb0\u0e99\u0eb3", icon: Compass },
] as const;

export function SettingsPage() {
  return (
    <>
      <Header />

      <Main>
        <div className="mb-4">
          <h2 className="font-bold text-2xl tracking-tight">
            {"\u0e81\u0eb2\u0e99\u0e95\u0eb1\u0ec9\u0e87\u0e84\u0ec8\u0eb2"}
          </h2>
          <p className="text-muted-foreground">
            {"\u0e88\u0eb1\u0e94\u0e81\u0eb2\u0e99\u0e9a\u0eb1\u0e99\u0e8a\u0eb5 \u0eae\u0eb9\u0e9a\u0ea5\u0eb1\u0e81\u0eaa\u0eb0\u0e99\u0eb0 \u0ec1\u0ea5\u0eb0 \u0e81\u0eb2\u0e99\u0e95\u0eb1\u0ec9\u0e87\u0e84\u0ec8\u0eb2\u0eaa\u0ec8\u0ea7\u0e99\u0e95\u0ebb\u0ea7"}
          </p>
        </div>

        <Tabs defaultValue="account" className="gap-6">
          <TabsList className="h-auto flex-wrap justify-start">
            {tabs.map(({ value, label, icon: Icon }) => (
              <TabsTrigger key={value} value={value}>
                <Icon className="size-4" />
                {label}
              </TabsTrigger>
            ))}
          </TabsList>

          <TabsContent value="shop">
            <ShopSettingsSection />
          </TabsContent>
          <TabsContent value="label-printer">
            <LabelPrinterSettingsSection />
          </TabsContent>
          <TabsContent value="import">
            <ImportOrderSettingsSection />
          </TabsContent>
          <TabsContent value="cod-risk">
            <CodRiskSettingsSection />
          </TabsContent>
          <TabsContent value="account">
            <AccountSection />
          </TabsContent>
          <TabsContent value="appearance">
            <AppearanceSection />
          </TabsContent>
          <TabsContent value="notifications">
            <NotificationsSection />
          </TabsContent>
          <TabsContent value="layout">
            <LayoutSection />
          </TabsContent>
          <TabsContent value="onboarding">
            <OnboardingSection />
          </TabsContent>
        </Tabs>
      </Main>
    </>
  );
}
